import { createRouter, createWebHistory } from 'vue-router'
import { getToken, removeToken } from '@/utils/storage'
import Layout from "@/views/Layout/Layout.vue"
import { restoreUserMenuRoutes, clearUserMenuRoutes } from '@/utils/dynamicRoutes'
import encrypt from '@/utils/crypto-util'

// 根据原型结构定义路由
const routes: Array<any> = [
    // 重定向根路径到登录页
    {
        path: "/",
        redirect: "/Login"
    },

    // 登录页
    {
        path: "/Login",
        component: () => import('../views/Login/login.vue')
    },

    // 仪表盘
    // {
    //     path: "/Dashboard",
    //     component: Layout,
    //     redirect: "Dashboard-DataStatistics",
    //     meta: '1111',
    //     children: [
    //         {
    //             path: 'Dashboard-DataStatistics',
    //             component: () => import('@/view/Dashboard/DataStatistics.vue'),
    //             meta: { title: '数据统计' }
    //         }
    //     ]
    // },

    // 账号管理
    // {
    //     path: "/Account",
    //     component: Layout,
    //     redirect: "AccountManagement-AccountList",
    //     meta: { title: '账号管理' },
    //     children: [
    //         {
    //             path: 'AccountManagement/AccountList',
    //             component: () => import('@/view/AccountManagement/AccountList.vue'),
    //             meta: { title: '账号列表' }
    //         },
    //         {
    //             path: 'AccountManagement-RoleList',
    //             component: () => import('@/view/AccountManagement/RoleList.vue'),
    //             meta: { title: '角色列表' }
    //         },
    //         {
    //             path: 'AccountManagement-PermissionList',
    //             component: () => import('@/view/AccountManagement/PermissionList.vue'),
    //             meta: { title: '权限列表' }
    //         }
    //     ]
    // },
    // // 推广管理
    // {
    //     path: "/promotion",
    //     component: HOME,
    //     redirect: "/promotion/promoters",
    //     meta: { title: '推广管理' },
    //     children: [
    //         {
    //             path: '/promotion/promoters',
    //             component: () => import('@/view/PromotionManagement/PromoterManagement.vue'),
    //             meta: { title: '推广者管理', rolelist: ['admin'] }
    //         },
    //         {
    //             path: '/promotion/certification',
    //             component: () => import('@/view/PromotionManagement/CertificationManagement.vue'),
    //             meta: { title: '认证管理' }
    //         },
    //         {
    //             path: '/promotion/media',
    //             component: () => import('@/view/PromotionManagement/MediaManagement.vue'),
    //             meta: { title: '媒体管理' }
    //         },
    //         {
    //             path: '/promotion/media-mapping',
    //             component: () => import('@/view/PromotionManagement/MediaMapping.vue'),
    //             meta: { title: '媒体映射' }
    //         },
    //         {
    //             path: '/promotion/ad-position',
    //             component: () => import('@/view/PromotionManagement/AdPositionManagement.vue'),
    //             meta: { title: '推广位管理' }
    //         },
    //         {
    //             path: '/promotion/ad-position-mapping',
    //             component: () => import('@/view/PromotionManagement/AdPositionMapping.vue'),
    //             meta: { title: '推广位映射' }
    //         },
    //         {
    //             path: '/promotion/activity',
    //             component: () => import('@/view/PromotionManagement/PromotionActivityManagement.vue'),
    //             meta: { title: '推广活动管理' }
    //         },
    //         {
    //             path: '/promotion/eleme-activity',
    //             component: () => import('@/view/PromotionManagement/ElemeActivityList.vue'),
    //             meta: { title: '饿了么-活动列表' }
    //         }
    //     ]
    // },
    // // 订单管理
    // {
    //     path: "/order",
    //     component: HOME,
    //     redirect: "/order/list",
    //     meta: { title: '订单管理' },
    //     children: [
    //         {
    //             path: '/order/list',
    //             component: () => import('@/view/OrderManagement/OrderList.vue'),
    //             meta: { title: '订单列表' }
    //         },
    //         {
    //             path: '/order/eleme-list',
    //             component: () => import('@/view/OrderManagement/ElemeOrderList.vue'),
    //             meta: { title: '饿了么-订单列表' }
    //         },
    //         {
    //             path: '/order/fliggy-list',
    //             component: () => import('@/view/OrderManagement/FliggyOrderList.vue'),
    //             meta: { title: '飞猪-订单列表' }
    //         },
    //         {
    //             path: '/order/settlement-list',
    //             component: () => import('@/view/OrderManagement/SettlementList.vue'),
    //             meta: { title: '结算单列表' }
    //         }
    //     ]
    // },
    // // 消息管理
    // {
    //     path: "/message",
    //     component: HOME,
    //     redirect: "/message/list",
    //     meta: { title: '消息管理' },
    //     children: [
    //         {
    //             path: '/message/list',
    //             component: () => import('@/view/MessageManagement/MessageList.vue'),
    //             meta: { title: '消息列表' }
    //         },
    //         {
    //             path: '/message/system-announcement',
    //             component: () => import('@/view/MessageManagement/SystemAnnouncement.vue'),
    //             meta: { title: '系统公告' }
    //         },
    //         {
    //             path: '/message/private-message',
    //             component: () => import('@/view/MessageManagement/PrivateMessage.vue'),
    //             meta: { title: '私信消息' }
    //         },
    //         {
    //             path: '/message/homepage-announcement',
    //             component: () => import('@/view/MessageManagement/HomepageAnnouncement.vue'),
    //             meta: { title: '首页公告' }
    //         }
    //     ]
    // },
    // // 配置管理
    // {
    //     path: "/config",
    //     component: HOME,
    //     redirect: "/config/academy-tutorial-type",
    //     meta: { title: '配置管理' },
    //     children: [
    //         {
    //             path: '/config/academy-tutorial-type',
    //             component: () => import('@/view/ConfigurationManagement/AcademyTutorialTypeConfig.vue'),
    //             meta: { title: '学院教程类型配置' }
    //         },
    //         {
    //             path: '/config/academy-tutorial',
    //             component: () => import('@/view/ConfigurationManagement/AcademyTutorialConfig.vue'),
    //             meta: { title: '学院教程配置' }
    //         },
    //         {
    //             path: '/config/faqs',
    //             component: () => import('@/view/ConfigurationManagement/FAQsConfig.vue'),
    //             meta: { title: 'FAQs配置' }
    //         }
    //     ]
    // },
    // // 系统管理
    // {
    //     path: "/system",
    //     component: HOME,
    //     redirect: "/system/third-party",
    //     meta: { title: '系统管理' },
    //     children: [
    //         {
    //             path: '/system/third-party',
    //             component: () => import('@/view/SystemManagement/ThirdPartyPlatformConfig.vue'),
    //             meta: { title: '三方平台配置' }
    //         },
    //         {
    //             path: '/system/eleme-venue',
    //             component: () => import('@/view/SystemManagement/ElemeVenueConfig.vue'),
    //             meta: { title: '饿了么会场配置' }
    //         },
    //         {
    //             path: '/system/upload',
    //             component: () => import('@/view/SystemManagement/UploadFile.vue'),
    //             meta: { title: '上传文件' }
    //         },
    //         {
    //             path: '/system/operation-log',
    //             component: () => import('@/view/SystemManagement/OperationLog.vue'),
    //             meta: { title: '操作日志' }
    //         }
    //     ]
    // },
    // 404页面
    {
        path: "/404",
        component: () => import('@/views/NotFound/NotFound.vue')
    },
    // 捕获所有未匹配的路由并重定向到404
    {
        path: "/:pathMatch(.*)*",
        redirect: "/404"
    }
]
//环境变量处理 路由
const getRouterBase = () => {
    const env = import.meta.env.VITE_APP_ENV || import.meta.env.MODE
    console.log('路由环境变量', env);
    console.log('BASE_URL:', import.meta.env.BASE_URL);
    // 对于使用相对路径 (./) 的情况，Vue Router 仍然需要知道实际的 base path
    // Vite 会自动将 base 配置注入到 import.meta.env.BASE_URL 中
    // 无论 base 是 './' 还是 '/'，我们都应该使用 BASE_URL
    switch (env) {
        case 'production':
            // 使用 Vite 注入的 BASE_URL，它会根据 vite.config.ts 中的 base 配置自动处理
            return '/'
        case 'test':
            return '/web/flkadmin/'
        case 'development':
            return '/'
        default:
            return '/'
    }
}
// 创建路由实例
const router = createRouter({
    history: createWebHistory(getRouterBase()),
    routes: routes
})

// 检查token是否有效的函数
const isTokenValid = (token: string | null): boolean => {
    if (!token) return false
    try {
        if (token.trim() === '') return false
        // 如果需要，可以在此处添加更多的token验证逻辑
        return true
    } catch (error) {
        console.error('Token validation error:', error)
        return false
    }
}

// 导航守卫
router.beforeEach(async (to, _from, next) => {
    console.log('🛣️ 路由守卫执行:', to.path, to.name)

    const token = getToken()
    const publicPages = ['/Login', '/404']
    const isPublicPage = publicPages.includes(to.path)

    if (isPublicPage) {
        console.log('✅ 公开页面，直接通过')
        next()
        return
    }

    if (!isTokenValid(token)) {
        console.log('❌ Token无效，清除数据并跳转登录')
        // 清除动态路由和用户信息
        clearUserMenuRoutes()
        removeToken()
        localStorage.removeItem('userinfo')
        localStorage.removeItem('uid')
        next('/Login')
        return
    }

    // 检查是否为动态路由
    const hasDynamicMenus = JSON.parse(encrypt.aesDecrypt(localStorage.getItem('dynamicMenus')))
    if (hasDynamicMenus) {
        try {
            const dynamicMenus = hasDynamicMenus
            const isValidDynamicRoute = dynamicMenus.some((menu: any) => {
                const checkRoute = (m: any) => {
                    if (m.value === to.path) return true
                    if (m.pageList && m.pageList.length > 0) {
                        return m.pageList.some((page: any) => page.value === to.path)
                    }
                    return false
                }
                return checkRoute(menu)
            })

            if (isValidDynamicRoute) {
                // 检查路由是否已存在
                const routeExists = router.getRoutes().some(route => route.path === to.path)

                if (!routeExists) {
                    console.log('🔄 动态路由不存在，尝试恢复:', to.path)
                    restoreUserMenuRoutes()

                    // 等待路由恢复完成后重新导航
                    await new Promise(resolve => setTimeout(resolve, 100))

                    const routeExistsAfterRestore = router.getRoutes().some(route => route.path === to.path)
                    if (routeExistsAfterRestore) {
                        console.log('✅ 路由恢复成功，重新导航')
                        next({ ...to, replace: true })
                    } else {
                        console.log('❌ 路由恢复失败，跳转404')
                        next('/404')
                    }
                    return
                }
                console.log('✅ 动态路由已存在')
            }
        } catch (error) {
            console.error('❌ 动态路由检查失败:', error)
            localStorage.removeItem('dynamicMenus')
        }
    }

    console.log('✅ 路由守卫通过')
    next()
})

// 导出路由实例
export default router
